import { ColorEnum } from '@/constants/color'
import Typography from '@/features/ui/typography'
import { FC } from 'react'

interface DescriptionProps {
    children: string
}

const Description: FC<DescriptionProps> = ({ children }) => {
    return (
        <Typography.Description
            size="small"
            font="medium"
            numberOfLines={1}
            style={{ color: ColorEnum.GRAY_600 }}
        >
            {children}
        </Typography.Description>
    )
}

export default Description
